// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8716) return "static/chunks/8716-ce9052017d9e7b22.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"10":"fee113878be024c6","1116":"d87acf0c3375c33d","1160":"a77c0a214e6cf3bb","1748":"a2a6d35184862c6d","3509":"e01e052f34366202","6820":"7ca72bdef2267d0b"}[chunkId] + ".js";
};